import { render, staticRenderFns } from "./accountmanagement.vue?vue&type=template&id=1b4374e8&"
import script from "./accountmanagement.vue?vue&type=script&lang=js&"
export * from "./accountmanagement.vue?vue&type=script&lang=js&"
import style0 from "./accountmanagement.vue?vue&type=style&index=0&id=1b4374e8&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/manage.pc.frontend-purchase-test/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1b4374e8')) {
      api.createRecord('1b4374e8', component.options)
    } else {
      api.reload('1b4374e8', component.options)
    }
    module.hot.accept("./accountmanagement.vue?vue&type=template&id=1b4374e8&", function () {
      api.rerender('1b4374e8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Urbanwarehouse/accountmanagement.vue"
export default component.exports